import { routes as Home } from '@/views/home/index.js'
import { routes as Transfer } from '@/views/transfer/index.js'
import { routes as Invoices } from '@/views/invoice/index.js'
import { routes as CategoriesManage } from '@/views/categories/index.js'
import { routes as ExternalEmployees } from '@/views/entities/index.js'

export default [
  {
    path: '/',
    name: 'dashboard',
    redirect: '/invoice',
    component: () => import('./Dashboard.vue'),
    meta: {
      name: 'Dashboard',
      auth: true,
      user: 'Admin',
    },
    children: [...Home, ...Transfer, ...CategoriesManage, ...ExternalEmployees, ...Invoices],
  },
]
